import { useState, useEffect, useMemo } from "react";
import { authService } from "../dependencyInjection";
import { unsubscribe } from "../../../../utils";
import { RequestStatus } from "../../shared";

type UseAuthLogin = (email: string, passwod: string) => Promise<void>;
type UseAuthLogout = () => void;
type UseAuthResult = [boolean, RequestStatus, UseAuthLogin, UseAuthLogout];

//** [isAuth, Pending, login, logout] */
export function useAuth(): UseAuthResult {
  const [isAuth, setIsAuth] = useState(authService.isAuth);
  const [status, setStatus] = useState(RequestStatus.None);
  useEffect(() => {
    const sub = authService.isAuth$.subscribe((authStatus) => {
      setIsAuth(authStatus);
    });
    return unsubscribe(sub);
  }, []);

  const login = useMemo<UseAuthLogin>(
    () => async (email, password) => {
      try {
        await authService.login(email, password);
      } catch (e) {
      }
    },
    [],
  );

  useEffect(() => {
    const sub = authService.status$.subscribe((code) => {
      setStatus(code);
    });
    return unsubscribe(sub);
  }, []);

  return [isAuth, status, login, authService.logout];
}
